export const shouldUpdatePublishedSegments = (
    existingPublishedIn: number[],
    publishedIn?: number[],
) => JSON.stringify(publishedIn) !== JSON.stringify(existingPublishedIn)
